webpackJsonp([0],{

/***/ 185:
/***/ (function(module, exports) {

module.exports = {"ronda-1":"Round 1","ronda-2":"Round 2","ronda-3":"Round 3","instrucciones":"Instructions"}

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.6ef5d20ab628c7f44ffc.js